// The server's API, typed from its OpenAPI document (`pnpm api` regenerates schema.ts).
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "./schema";

export type { components } from "./schema";

/** An error body from the server: a stable snake_case code and a message for people. */
export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string, public details?: unknown) {
    super(message);
  }
}

// Assessed uploads require exact selection readback, completion batches past
// 8 items need `complete_batch_max_items`, and empty files settle in start
// batches (`settles_empty_files`). Older clients keep the legacy
// representations until they explicitly support those protocols.
export const fetchClient = createFetchClient<paths>({
  baseUrl: "", headers: { "X-Celia-Features": "upload-preflight-v2, upload-complete-batch-v2, upload-empty-files-v1" },
});

fetchClient.use({
  async onResponse({ response }) {
    if (response.ok) return response;
    let body: { error?: string; message?: string; details?: unknown } = {};
    try { body = await response.clone().json(); } catch { /* not JSON */ }
    if (response.status === 401 && !location.pathname.startsWith("/login")) {
      location.assign(`/login?return=${encodeURIComponent(location.pathname + location.search)}`);
    }
    throw new ApiError(response.status, body.error ?? "http_error", body.message ?? response.statusText, body.details);
  },
});

export const api = createClient(fetchClient);
